import { memo } from "react";
import { Bill, BillSource } from "@common/types/bill";
import { AccountCard } from "@components/financialAccount/AccountCard/AccountCard";
import { QuickbooksAccountCard } from "@components/invoices/views/QuickbooksAccountCard";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";

export const BillAccountContent = memo(({ bill }: { bill?: Bill }) => {
    if (bill?.financialAccount) {
        return (
            <AccountCard
                account={bill.financialAccount}
                onlyNumber
                showType={false}
                iconSize="sm"
            />
        );
    }
    if (bill?.source === BillSource.QUICKBOOKS) {
        return <QuickbooksAccountCard iconSize="sm" />;
    }
    return <EmptyValue />;
});
BillAccountContent.displayName = "BillAccountContent";
